import { ToggleButton } from "plos/src/components/ToggleButton";
import { ToggleButtonGroup } from "plos/src/components/ToggleButtonGroup";
import { Key } from "react";
import { useTranslation } from "react-i18next";
import type { PriceChangesView } from "../usePriceChangeControls";
import styles from "./priceChangesViewToggle.module.css";

export interface PriceChangesViewToggleProps {
  selected: PriceChangesView;
  handleViewChange: (keys: Set<PriceChangesView>) => void;
}

const PriceChangesViewToggle = ({
  selected,
  handleViewChange,
}: PriceChangesViewToggleProps) => {
  const { t } = useTranslation("priceChanges");
  const handleSelectionChange = (keys: Set<Key>) => {
    handleViewChange(keys as Set<PriceChangesView>);
  };

  return (
    <div className={styles.wrapper}>
      <ToggleButtonGroup
        aria-label={t("viewToggle.label", "Price changes view")}
        selectedKeys={new Set([selected])}
        onSelectionChange={handleSelectionChange}
      >
        <ToggleButton id="predictions">
          {t("viewToggle.predictions", "Predictions")}
        </ToggleButton>
        <ToggleButton id="history">
          {t("viewToggle.history", "Recent Price Changes")}
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};

export default PriceChangesViewToggle;
